// project-imports
import { DrawerHeader, DrawerOverlay, useDrawerLogic } from '../common';
import VerticalDrawerContent from './VerticalDrawerContent';
import { useReduxTheme } from 'hooks/useReduxTheme';

// ==============================|| VERTICAL DRAWER ||============================== //

export const VerticalDrawer = () => {
  const { drawerOpen, selectedItems, setSelectedItems, isMobile, overlayRef } = useDrawerLogic();
  const { themeMode } = useReduxTheme();

  return (
    <nav
      id="pc-sidebar"
      className={`pc-sidebar ${drawerOpen && 'pc-sidebar-hide mob-sidebar-active'} ${themeMode === 'dark' ? 'sidebar-dark' : 'sidebar-light'}`}
    >
      <div className="navbar-wrapper">
        {/* <DrawerHeader /> */}
        <div className="navbar-content">
          <VerticalDrawerContent selectedItems={selectedItems} setSelectedItems={setSelectedItems} />
        </div>
      </div>
      <DrawerOverlay drawerOpen={drawerOpen} isMobile={isMobile} overlayRef={overlayRef} />
    </nav>
  );
};
